import { render, staticRenderFns } from "./open-account-record.vue?vue&type=template&id=3b060aa8&"
import script from "./open-account-record.vue?vue&type=script&lang=js&"
export * from "./open-account-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports